/**
 * Housing Page JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

import 'lightgallery';
import 'lg-thumbnail';
import gumshoe from 'gumshoejs';

/**
 * Class PageHousing
 */
class PageHousing {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

        // Current sort key
        this.sortKey = 'flat-number';
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Anchor links navigation
        this.anchorLinksNavigation = $( '.main-nav__anchorlinks' );

        // Anchor links navigation list
        this.anchorLinksList = $( '.main-nav__anchorlinks__list' );

        // Scrollspy targets
        this.scrollspyTargets = $( '[data-scrollspy="true"]' );

        // Hero
        this.hero = $( '.hero' );

        // Hero image gallery
        this.gallery = $( '.hero__gallery' );

        // Hero image gallery thumbnails
        this.galleryThumbs = $( '.hero__gallery__anchor' );

        // Hero image gallery json
        this.galleryJSON = this.gallery.data( 'gallery' );

        // Apartments table sorting
        this.apartmentsSorting = $( '.apartments-table__head span' );

        // Apartments container
        this.apartmentsContainer = $( '.apartments-table__data' );

        // Apartments as array
        this.apartments = $( '.apartments-table__data__row-item' ).toArray();

        // Map
        this.map = $( '#map' );
    }

    /**
     * Populate the anchor links navigation by the targets found on the page
     */
    populateAnchorLinks() {

        this.scrollspyTargets.each( ( index, target ) => {

            this.anchorLinksList.append( '<li class="main-nav__anchorlinks__list__item"><a href="#' + target.id + '" class="main-nav__anchorlinks__list__item__link">' + $( target ).data('title') + '</a></li>' );
        });
    }

    /**
     * Initialize the anchor links navigation
     */
    initAnchorLinks() {

        // This is the amount in pixels that user needs to scroll before the navigation appears
        const distanceFromTop = this.hero.height() / 2;

        // When the user scrolls down from the top of the document, show the menu
        $( window ).scroll( () => {

            if ( document.body.scrollTop > distanceFromTop || document.documentElement.scrollTop > distanceFromTop ) {

                this.anchorLinksNavigation.removeClass( 'js-hidden' );
            } else {

                this.anchorLinksNavigation.addClass( 'js-hidden' );
            }
        });

        // JavaScript enabled scrolling
        $( '.main-nav__anchorlinks__list__item__link' ).each( ( index, anchorLink ) => {

            const $anchorLink = $( anchorLink );

            $anchorLink.on( 'click', ( e ) => {

                e.preventDefault();

                $([ document.documentElement, document.body ]).animate({
                    scrollTop: $( $( e.target ).attr( 'href' ) ).offset().top - 50
                }, 500 );
            });
        });

        // Scrollspy
        this.anchorLinksNavigation.attr( 'data-gumshoe-header', '' );
        this.anchorLinksList.attr( 'data-gumshoe', '' );

        gumshoe.init({
            offset: 50,         // Distance in pixels to offset calculations
            scrollDelay: true   // Wait until scrolling has stopped before updating the navigation
        });
    }

    /**
     * Initialize the gallery on thumbnail click
     */
    initGallery() {

        if ( this.gallery.length ) {

            this.galleryThumbs.each( ( index, galleryThumb ) => {

                const $galleryThumb = $( galleryThumb );

                $galleryThumb.on( 'click', ( e ) => {

                    e.preventDefault();

                    // Init the lightgallery and jump to the right slide
                    const slideToOpen = $galleryThumb.index();

                    $galleryThumb.lightGallery({
                        dynamic: true,
                        dynamicEl: this.galleryJSON,
                        index: slideToOpen,
                        download: false,
                        thumbnail: true
                    });
                });
            });
        }
    }

    /**
     * Initialize the apartments table sorting
     */
    initApartmentsTableSorting() {

        if ( this.apartmentsSorting.length ) {

            $( this.apartmentsSorting[0] ).addClass( 'is-active' );
            this.apartmentsSorting.on( 'click', ( e ) => {

                e.preventDefault();

                // Sort the apartments
                const sortKey = $( e.target ).data( 'sort-key' );
                this.sortApartments( sortKey );

                // Set sorting active state
                this.apartmentsSorting.removeClass( 'is-active' );
                $( e.target ).addClass( 'is-active' );
            });
        }
    }

    /**
     * Initialize the apartments table sorting
     */
    sortApartments( key ) {

        // Detach apartments from DOM before sorting them
        $( this.apartments ).detach();

        if ( this.sortKey == key ) {

            // If clicking the same key, reverse order
            this.apartments.reverse();

            // Keep the status ordering intact
            this.sortApartmentsByStatusAndType();
        } else {

            this.apartments.sort( ( a, b ) => {

                this.sortApartmentsByStatusAndType();

                // Use the correct sorting method
                if ( key == 'flat-number' ) {

                    const flatNumA  = $( a ).data( key ).replace ( /[^\d.]/g, '' );
                    const flatCharA = $( a ).data( key ).replace ( flatNumA, '' );
                    const flatNumB  = $( b ).data( key ).replace ( /[^\d.]/g, '' );
                    const flatCharB = $( b ).data( key ).replace ( flatNumB, '' );

                    if ( flatCharA.localeCompare( flatCharB ) === -1 ) {

                        // Sort by letter
                        return -1;
                    } else {

                        // Sort by number
                        return flatNumA - flatNumB;
                    }
                } else {

                    // Basic numeric sorting
                    return $( a ).data( key ) - $( b ).data( key );
                }
            });
        }

        // Set the current sorting key
        this.sortKey = key;

        // Re-order the DOM
        $.each( this.apartments, function( key, apartment ) {
            $( apartment ).appendTo( '.apartments-table__data' );
        });
    }

    /**
     * Sort apartments by status and type
     */
    sortApartmentsByStatusAndType() {

        const sts = 'status';
        const tp  = 'type';

        this.apartments.sort( ( a, b ) => {

            // Keep the status ordering intact
            if ( $( a ).data( sts ) === 'Varattu' && $( b ).data( sts ) === 'Myynnissä' ) {

                return 1;
            } else if ( $( a ).data( sts ) === 'Myynnissä' && $( b ).data( sts ) === 'Varattu' ) {

                return -1;
            } else if ( $( a ).data( tp ) === 'AP' && $( b ).data( tp ) === 'KT' ) {

                return 1;
            } else if ( $( a ).data( tp ) === 'KT' && $( b ).data( tp ) === 'AP' ) {

                return -1;
            }
        });
    }

    /**
     * Initialize the Google Maps embed
     */
    initMap() {

        // The location
        const loc = {
            lat: $( this.map ).data( 'lat' ),
            lng: $( this.map ).data( 'lng' )
        };

        // The map
        const mapEmbed = new google.maps.Map(
            $( this.map )[0],
            {
                zoom: 16,
                center: loc
            }
        );

        // The marker
        const marker = new google.maps.Marker({
            position: loc,
            map: mapEmbed
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {

        this.cache();
        this.populateAnchorLinks();
        this.initAnchorLinks();
        this.initGallery();
        this.initApartmentsTableSorting();

        // Init map when the Google Maps JavaScript API says so
        google.maps.event.addDomListener( window, 'load', this.initMap );
    }
}

// Export the class reference.
module.exports = PageHousing;



// WEBPACK FOOTER //
// ./assets/scripts/page-housing.js